import instance, { formDataInstance } from "./baseRequest";

export const pickupDeliveryApi = {
  getPickupDelivery: async () => instance.get("/pickup-delivery"),
  updatePickupDelivery: async ({ service, imageFile, link }) => {
    const formData = new FormData();
    if (imageFile) formData.append("image", imageFile);
    if (link !== undefined) formData.append("link", link);
    return formDataInstance.put(`/pickup-delivery/${service}`, formData);
  },
};
